import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';

import { cn } from '@/lib/utils';
import { FormLabel } from '../form/form.component';

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return <RadioGroupPrimitive.Root className={cn('grid', className)} {...props} ref={ref} />;
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, checked, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'flex flex-row items-center border border-other-stroke px-3 py-[2px]',
        'cursor-pointer',
        'focus:outline-primary',
        'disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          'h-5 w-5 rounded-full border border-other-stroke mr-4 flex items-center justify-center',
          checked ? 'border-primary bg-primary' : 'border-other-stroke bg-transparent',
        )}
      >
        <RadioGroupPrimitive.Indicator>
          <div className="h-2.5 w-2.5 bg-white rounded-full" />
        </RadioGroupPrimitive.Indicator>
      </div>
      <FormLabel className="typo-primary-400 cursor-pointer">{props.value}</FormLabel>
    </RadioGroupPrimitive.Item>
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
